// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"75b28f57","488":"ddaf5d9d","694":"903dc625"}[chunkId] + ".chunk.js";
};